import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';

@Injectable({
  providedIn: 'root'
})
export class StationService {
  stationTypes: any;

  constructor(private $shttp: SuperHttpClientProvider) {}

  getStationTypes() {
    return this.$shttp.default.get('/enum/stationType');
  }
}
